// Club-wide ordering: oldest age group first (U18 … U4), Adults before U18, unknown last.
export const ageRank = (ag) => {
  const s = String(ag || "").trim();
  if (!s) return -1;
  if (/^(adult|>|vet|senior|open)/i.test(s)) return 99 + (parseInt((/\d+/.exec(s) || ["0"])[0], 10) || 0);
  const m = /^u\s*(\d+)/i.exec(s);
  return m ? parseInt(m[1], 10) : 0;
};

export const compareAge = (a, b) => ageRank(b) - ageRank(a) || String(a || "").localeCompare(String(b || ""));

export const compareTeams = (a, b) => compareAge(a?.age_group, b?.age_group) || (a?.name || "").localeCompare(b?.name || "", undefined, { sensitivity: "base" });

export const sortAges = (list) => [...list].sort(compareAge);
export const sortTeams = (list) => [...(list || [])].sort(compareTeams);
